//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse, HttpResponseBase } from '@angular/common/http';

export const LOCALIZATION_ADMIN_API_BASE_URL = new InjectionToken<string>('LOCALIZATION_ADMIN_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class AdminCacheClient {
    protected http: HttpClient;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(
	@Inject(HttpClient) http: HttpClient,
	@Optional() @Inject(LOCALIZATION_ADMIN_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    flush(): Observable<AdminCacheFlushResultDto> {
        let url_ = this.baseUrl + "/admin/cache/flush";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFlush(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFlush(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminCacheFlushResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminCacheFlushResultDto>;
        }));
    }

    protected processFlush(response: HttpResponseBase): Observable<AdminCacheFlushResultDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminCacheFlushResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminCacheClient.Flush');
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AdminEditorClient {
    protected http: HttpClient;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(
	@Inject(HttpClient) http: HttpClient,
	@Optional() @Inject(LOCALIZATION_ADMIN_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getTree(): Observable<AdminGroupTreeNodeDto> {
        let url_ = this.baseUrl + "/admin/editor/tree";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTree(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTree(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminGroupTreeNodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminGroupTreeNodeDto>;
        }));
    }

    protected processGetTree(response: HttpResponseBase): Observable<AdminGroupTreeNodeDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminGroupTreeNodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminEditorClient.GetTree');
            }));
        }
        return _observableOf(null as any);
    }

    search(request: AdminSearchTagsRequestDto): Observable<SwaggerResponse<AdminTagDto[]>> {
        let url_ = this.baseUrl + "/admin/editor/search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwaggerResponse<AdminTagDto[]>>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwaggerResponse<AdminTagDto[]>>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<SwaggerResponse<AdminTagDto[]>> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AdminTagDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return _observableOf(new SwaggerResponse(status, _headers, result200));
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminEditorProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminEditorClient.Search');
            }));
        }
        return _observableOf<SwaggerResponse<AdminTagDto[]>>(new SwaggerResponse(status, _headers, null as any));
    }

    getTag(tagId: number): Observable<AdminTagDto> {
        let url_ = this.baseUrl + "/admin/editor/tags/{tagId}";
        if (tagId === undefined || tagId === null)
            throw new globalThis.Error("The parameter 'tagId' must be defined.");
        url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminTagDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminTagDto>;
        }));
    }

    protected processGetTag(response: HttpResponseBase): Observable<AdminTagDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminTagDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminEditorProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminEditorClient.GetTag');
            }));
        }
        return _observableOf(null as any);
    }

    createGroup(request: AdminCreateNodeRequestDto): Observable<AdminNodeDto> {
        let url_ = this.baseUrl + "/admin/editor/groups";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateGroup(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateGroup(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminNodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminNodeDto>;
        }));
    }

    protected processCreateGroup(response: HttpResponseBase): Observable<AdminNodeDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminNodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminEditorProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = XProblemDetailsOfAdminEditorProblemCode.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminEditorClient.CreateGroup');
            }));
        }
        return _observableOf(null as any);
    }

    createTag(request: AdminCreateNodeRequestDto): Observable<AdminNodeDto> {
        let url_ = this.baseUrl + "/admin/editor/tags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTag(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTag(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminNodeDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminNodeDto>;
        }));
    }

    protected processCreateTag(response: HttpResponseBase): Observable<AdminNodeDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminNodeDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminEditorProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = XProblemDetailsOfAdminEditorProblemCode.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminEditorClient.CreateTag');
            }));
        }
        return _observableOf(null as any);
    }

    renameNode(nodeId: number, request: AdminRenameNodeRequestDto): Observable<void> {
        let url_ = this.baseUrl + "/admin/editor/nodes/{nodeId}/name";
        if (nodeId === undefined || nodeId === null)
            throw new globalThis.Error("The parameter 'nodeId' must be defined.");
        url_ = url_.replace("{nodeId}", encodeURIComponent("" + nodeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenameNode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenameNode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRenameNode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminEditorProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = XProblemDetailsOfAdminEditorProblemCode.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminEditorClient.RenameNode');
            }));
        }
        return _observableOf(null as any);
    }

    moveNode(nodeId: number, request: AdminMoveNodeRequestDto): Observable<void> {
        let url_ = this.baseUrl + "/admin/editor/nodes/{nodeId}/parent";
        if (nodeId === undefined || nodeId === null)
            throw new globalThis.Error("The parameter 'nodeId' must be defined.");
        url_ = url_.replace("{nodeId}", encodeURIComponent("" + nodeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMoveNode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMoveNode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processMoveNode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminEditorProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = XProblemDetailsOfAdminEditorProblemCode.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminEditorClient.MoveNode');
            }));
        }
        return _observableOf(null as any);
    }

    removeNode(nodeId: number, force?: boolean | undefined): Observable<void> {
        let url_ = this.baseUrl + "/admin/editor/nodes/{nodeId}?";
        if (nodeId === undefined || nodeId === null)
            throw new globalThis.Error("The parameter 'nodeId' must be defined.");
        url_ = url_.replace("{nodeId}", encodeURIComponent("" + nodeId));
        if (force === null)
            throw new globalThis.Error("The parameter 'force' cannot be null.");
        else if (force !== undefined)
            url_ += "force=" + encodeURIComponent("" + force) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveNode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveNode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveNode(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminEditorProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = XProblemDetailsOfAdminEditorProblemCode.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminEditorClient.RemoveNode');
            }));
        }
        return _observableOf(null as any);
    }

    setTagValue(tagId: number, language: ValueLanguage, request: AdminSetTagValueRequestDto): Observable<AdminTagValueDto> {
        let url_ = this.baseUrl + "/admin/editor/tags/{tagId}/values/{language}";
        if (tagId === undefined || tagId === null)
            throw new globalThis.Error("The parameter 'tagId' must be defined.");
        url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
        if (language === undefined || language === null)
            throw new globalThis.Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetTagValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetTagValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminTagValueDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminTagValueDto>;
        }));
    }

    protected processSetTagValue(response: HttpResponseBase): Observable<AdminTagValueDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminTagValueDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminEditorProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = XProblemDetailsOfAdminEditorProblemCode.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminEditorClient.SetTagValue');
            }));
        }
        return _observableOf(null as any);
    }

    removeTagValue(tagId: number, language: ValueLanguage): Observable<void> {
        let url_ = this.baseUrl + "/admin/editor/tags/{tagId}/values/{language}";
        if (tagId === undefined || tagId === null)
            throw new globalThis.Error("The parameter 'tagId' must be defined.");
        url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
        if (language === undefined || language === null)
            throw new globalThis.Error("The parameter 'language' must be defined.");
        url_ = url_.replace("{language}", encodeURIComponent("" + language));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemoveTagValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemoveTagValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processRemoveTagValue(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return _observableOf(null as any);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminEditorProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = XProblemDetailsOfAdminEditorProblemCode.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminEditorClient.RemoveTagValue');
            }));
        }
        return _observableOf(null as any);
    }

    upsertTagValue(request: AdminUpsertTagValueRequestDto): Observable<AdminUpsertTagValueResponseDto> {
        let url_ = this.baseUrl + "/admin/editor/tag/upsert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpsertTagValue(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpsertTagValue(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminUpsertTagValueResponseDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminUpsertTagValueResponseDto>;
        }));
    }

    protected processUpsertTagValue(response: HttpResponseBase): Observable<AdminUpsertTagValueResponseDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminUpsertTagValueResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminEditorProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status === 403) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = XProblemDetailsOfAdminEditorProblemCode.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            }));
        } else if (status === 404) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminEditorClient.UpsertTagValue');
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AdminMigrateClient {
    protected http: HttpClient;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(
	@Inject(HttpClient) http: HttpClient,
	@Optional() @Inject(LOCALIZATION_ADMIN_API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    export(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/admin/migrate/export";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBody as any, status: status, headers: _headers });
        } else if (status === 400) {
            return blobToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminEditorProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminMigrateClient.Export');
            }));
        }
        return _observableOf(null as any);
    }

    replace(file?: FileParameter | null | undefined): Observable<AdminImportResultDto> {
        let url_ = this.baseUrl + "/admin/migrate/replace";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "json",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReplace(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReplace(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AdminImportResultDto>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AdminImportResultDto>;
        }));
    }

    protected processReplace(response: HttpResponseBase): Observable<AdminImportResultDto> {
        const status = response.status;
        const responseBody =
            response instanceof HttpResponse
                ? response.body
                : response instanceof HttpErrorResponse
                    ? response.error
                    : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AdminImportResultDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = XProblemDetailsOfAdminEditorProblemCode.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return anyToText(responseBody).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers, undefined, 'AdminMigrateClient.Replace');
            }));
        }
        return _observableOf(null as any);
    }
}

export class AdminCacheFlushResultDto implements IAdminCacheFlushResultDto {
    languagesCleared!: string[];
    flushedAt!: Date;

    constructor(data?: IAdminCacheFlushResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.languagesCleared = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["languagesCleared"])) {
                this.languagesCleared = [] as any;
                for (let item of _data["languagesCleared"])
                    this.languagesCleared!.push(item);
            }
            this.flushedAt = _data["flushedAt"] ? new Date(_data["flushedAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): AdminCacheFlushResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminCacheFlushResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.languagesCleared)) {
            data["languagesCleared"] = [];
            for (let item of this.languagesCleared)
                data["languagesCleared"].push(item);
        }
        data["flushedAt"] = this.flushedAt ? this.flushedAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IAdminCacheFlushResultDto {
    languagesCleared: string[];
    flushedAt: Date;
}

export class AdminGroupTreeNodeDto implements IAdminGroupTreeNodeDto {
    id!: number;
    name!: string;
    parentId!: number | undefined;
    createdAt!: Date;
    modifiedAt!: Date;
    tagCount!: number;
    children!: AdminGroupTreeNodeDto[];

    constructor(data?: IAdminGroupTreeNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.children = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.tagCount = _data["tagCount"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(AdminGroupTreeNodeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdminGroupTreeNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminGroupTreeNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["tagCount"] = this.tagCount;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAdminGroupTreeNodeDto {
    id: number;
    name: string;
    parentId: number | undefined;
    createdAt: Date;
    modifiedAt: Date;
    tagCount: number;
    children: AdminGroupTreeNodeDto[];
}

export class AdminTagDto implements IAdminTagDto {
    id!: number;
    name!: string;
    parentId!: number;
    parentName!: string | undefined;
    createdAt!: Date;
    modifiedAt!: Date;
    createdByStaffName!: string | undefined;
    modifiedByStaffName!: string | undefined;
    values!: AdminTagValueDto[];

    constructor(data?: IAdminTagDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.values = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
            this.parentName = _data["parentName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.createdByStaffName = _data["createdByStaffName"];
            this.modifiedByStaffName = _data["modifiedByStaffName"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(AdminTagValueDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AdminTagDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminTagDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["parentName"] = this.parentName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["createdByStaffName"] = this.createdByStaffName;
        data["modifiedByStaffName"] = this.modifiedByStaffName;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

export interface IAdminTagDto {
    id: number;
    name: string;
    parentId: number;
    parentName: string | undefined;
    createdAt: Date;
    modifiedAt: Date;
    createdByStaffName: string | undefined;
    modifiedByStaffName: string | undefined;
    values: AdminTagValueDto[];
}

export class AdminTagValueDto implements IAdminTagValueDto {
    language!: ValueLanguage;
    text!: string;
    modifiedAt!: Date | undefined;
    modifiedByStaffName!: string | undefined;

    constructor(data?: IAdminTagValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.language = _data["language"];
            this.text = _data["text"];
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.modifiedByStaffName = _data["modifiedByStaffName"];
        }
    }

    static fromJS(data: any): AdminTagValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminTagValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["language"] = this.language;
        data["text"] = this.text;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["modifiedByStaffName"] = this.modifiedByStaffName;
        return data;
    }
}

export interface IAdminTagValueDto {
    language: ValueLanguage;
    text: string;
    modifiedAt: Date | undefined;
    modifiedByStaffName: string | undefined;
}

export enum ValueLanguage {
    Ru = "Ru",
    En = "En",
    Fr = "Fr",
    He = "He",
    EnUk = "EnUk",
    EnUs = "EnUs",
    It = "It",
    RuBy = "RuBy",
    RuKz = "RuKz",
    RuKg = "RuKg",
    RuMd = "RuMd",
    RuUz = "RuUz",
    RuTj = "RuTj",
    Kk = "Kk",
    Ky = "Ky",
    Ro = "Ro",
    Uz = "Uz",
    Tg = "Tg",
    Trl = "Trl",
}

export class ProblemDetails implements IProblemDetails {
    type!: string | undefined;
    title!: string | undefined;
    status!: number | undefined;
    detail!: string | undefined;
    instance!: string | undefined;
    extensions!: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (this.extensions as any)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (data["extensions"] as any)[key] = (this.extensions as any)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;
    extensions: { [key: string]: any; };

    [key: string]: any;
}

export class XProblemDetailsOfAdminEditorProblemCode extends ProblemDetails implements IXProblemDetailsOfAdminEditorProblemCode {
    problemCode!: AdminEditorProblemCode;

    [key: string]: any;

    constructor(data?: IXProblemDetailsOfAdminEditorProblemCode) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.problemCode = _data["problemCode"];
        }
    }

    static override fromJS(data: any): XProblemDetailsOfAdminEditorProblemCode {
        data = typeof data === 'object' ? data : {};
        let result = new XProblemDetailsOfAdminEditorProblemCode();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["problemCode"] = this.problemCode;
        super.toJSON(data);
        return data;
    }
}

export interface IXProblemDetailsOfAdminEditorProblemCode extends IProblemDetails {
    problemCode: AdminEditorProblemCode;

    [key: string]: any;
}

export enum AdminEditorProblemCode {
    Undefined = "Undefined",
    NodeNotFound = "NodeNotFound",
    ParentGroupNotFound = "ParentGroupNotFound",
    NodeNameBusy = "NodeNameBusy",
    InvalidNodeName = "InvalidNodeName",
    TagValueNotFound = "TagValueNotFound",
    InvalidTagText = "InvalidTagText",
    RootNodeCanNotBeRemoved = "RootNodeCanNotBeRemoved",
    RootNodeCanNotBeMoved = "RootNodeCanNotBeMoved",
    GroupIsNotEmpty = "GroupIsNotEmpty",
    NodeCycle = "NodeCycle",
    MissingRootNode = "MissingRootNode",
    EmptyFile = "EmptyFile",
    InvalidPayload = "InvalidPayload",
    EditorDisabled = "EditorDisabled",
}

export class AdminSearchTagsRequestDto implements IAdminSearchTagsRequestDto {
    name!: string | undefined;
    valueText!: string | undefined;
    language!: ValueLanguage | undefined;
    groupId!: number | undefined;
    includeSubgroups!: boolean;
    sort!: AdminTagSort;
    descending!: boolean;
    page!: number | undefined;
    pageSize!: number | undefined;

    constructor(data?: IAdminSearchTagsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.valueText = _data["valueText"];
            this.language = _data["language"];
            this.groupId = _data["groupId"];
            this.includeSubgroups = _data["includeSubgroups"];
            this.sort = _data["sort"];
            this.descending = _data["descending"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }

    static fromJS(data: any): AdminSearchTagsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminSearchTagsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["valueText"] = this.valueText;
        data["language"] = this.language;
        data["groupId"] = this.groupId;
        data["includeSubgroups"] = this.includeSubgroups;
        data["sort"] = this.sort;
        data["descending"] = this.descending;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}

export interface IAdminSearchTagsRequestDto {
    name: string | undefined;
    valueText: string | undefined;
    language: ValueLanguage | undefined;
    groupId: number | undefined;
    includeSubgroups: boolean;
    sort: AdminTagSort;
    descending: boolean;
    page: number | undefined;
    pageSize: number | undefined;
}

export enum AdminTagSort {
    Undefined = "Undefined",
    Id = "Id",
    Name = "Name",
    CreatedAt = "CreatedAt",
    ModifiedAt = "ModifiedAt",
}

export class AdminNodeDto implements IAdminNodeDto {
    id!: number;
    name!: string;
    parentId!: number | undefined;
    type!: NodeType;
    createdAt!: Date;
    modifiedAt!: Date;
    createdByStaffName!: string | undefined;
    modifiedByStaffName!: string | undefined;

    constructor(data?: IAdminNodeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.parentId = _data["parentId"];
            this.type = _data["type"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
            this.modifiedAt = _data["modifiedAt"] ? new Date(_data["modifiedAt"].toString()) : undefined as any;
            this.createdByStaffName = _data["createdByStaffName"];
            this.modifiedByStaffName = _data["modifiedByStaffName"];
        }
    }

    static fromJS(data: any): AdminNodeDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminNodeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["parentId"] = this.parentId;
        data["type"] = this.type;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        data["modifiedAt"] = this.modifiedAt ? this.modifiedAt.toISOString() : undefined as any;
        data["createdByStaffName"] = this.createdByStaffName;
        data["modifiedByStaffName"] = this.modifiedByStaffName;
        return data;
    }
}

export interface IAdminNodeDto {
    id: number;
    name: string;
    parentId: number | undefined;
    type: NodeType;
    createdAt: Date;
    modifiedAt: Date;
    createdByStaffName: string | undefined;
    modifiedByStaffName: string | undefined;
}

export enum NodeType {
    Group = 1,
    Tag = 2,
}

export class AdminCreateNodeRequestDto implements IAdminCreateNodeRequestDto {
    name!: string;
    parentGroupId!: number;

    constructor(data?: IAdminCreateNodeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.parentGroupId = _data["parentGroupId"];
        }
    }

    static fromJS(data: any): AdminCreateNodeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminCreateNodeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["parentGroupId"] = this.parentGroupId;
        return data;
    }
}

export interface IAdminCreateNodeRequestDto {
    name: string;
    parentGroupId: number;
}

export class AdminRenameNodeRequestDto implements IAdminRenameNodeRequestDto {
    name!: string;

    constructor(data?: IAdminRenameNodeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): AdminRenameNodeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminRenameNodeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

export interface IAdminRenameNodeRequestDto {
    name: string;
}

export class AdminMoveNodeRequestDto implements IAdminMoveNodeRequestDto {
    parentGroupId!: number;

    constructor(data?: IAdminMoveNodeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentGroupId = _data["parentGroupId"];
        }
    }

    static fromJS(data: any): AdminMoveNodeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminMoveNodeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentGroupId"] = this.parentGroupId;
        return data;
    }
}

export interface IAdminMoveNodeRequestDto {
    parentGroupId: number;
}

export class AdminSetTagValueRequestDto implements IAdminSetTagValueRequestDto {
    text!: string;

    constructor(data?: IAdminSetTagValueRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): AdminSetTagValueRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminSetTagValueRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        return data;
    }
}

export interface IAdminSetTagValueRequestDto {
    text: string;
}

export class AdminUpsertTagValueResponseDto implements IAdminUpsertTagValueResponseDto {
    tagId!: number;
    tagName!: string | undefined;
    language!: ValueLanguage;
    text!: string | undefined;

    constructor(data?: IAdminUpsertTagValueResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagId = _data["tagId"];
            this.tagName = _data["tagName"];
            this.language = _data["language"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): AdminUpsertTagValueResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUpsertTagValueResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagId"] = this.tagId;
        data["tagName"] = this.tagName;
        data["language"] = this.language;
        data["text"] = this.text;
        return data;
    }
}

export interface IAdminUpsertTagValueResponseDto {
    tagId: number;
    tagName: string | undefined;
    language: ValueLanguage;
    text: string | undefined;
}

export class AdminUpsertTagValueRequestDto implements IAdminUpsertTagValueRequestDto {
    tagName!: string;
    language!: ValueLanguage;
    text!: string;

    constructor(data?: IAdminUpsertTagValueRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tagName = _data["tagName"];
            this.language = _data["language"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): AdminUpsertTagValueRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminUpsertTagValueRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tagName"] = this.tagName;
        data["language"] = this.language;
        data["text"] = this.text;
        return data;
    }
}

export interface IAdminUpsertTagValueRequestDto {
    tagName: string;
    language: ValueLanguage;
    text: string;
}

export class AdminImportResultDto implements IAdminImportResultDto {
    nodesImported!: number;
    groupsImported!: number;
    tagsImported!: number;
    valuesImported!: number;

    constructor(data?: IAdminImportResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.nodesImported = _data["nodesImported"];
            this.groupsImported = _data["groupsImported"];
            this.tagsImported = _data["tagsImported"];
            this.valuesImported = _data["valuesImported"];
        }
    }

    static fromJS(data: any): AdminImportResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new AdminImportResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["nodesImported"] = this.nodesImported;
        data["groupsImported"] = this.groupsImported;
        data["tagsImported"] = this.tagsImported;
        data["valuesImported"] = this.valuesImported;
        return data;
    }
}

export interface IAdminImportResultDto {
    nodesImported: number;
    groupsImported: number;
    tagsImported: number;
    valuesImported: number;
}

export class SwaggerResponse<TResult> {
    status: number;
    headers: { [key: string]: any; };
    result: TResult;

    constructor(status: number, headers: { [key: string]: any; }, result: TResult)
    {
        this.status = status;
        this.headers = headers;
        this.result = result;
    }
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;
    operationName: string;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any, operationName?: string) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
        this.operationName = operationName ?? '';
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any, operationName?: string): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null, operationName));
}

function anyToText(data: unknown): Observable<string>{
    if (data instanceof Blob) return blobToText(data);
    return new Observable<string>(observer => {
        if (!data) {
            observer.next("");
            observer.complete();
            return;
        }
        observer.next(JSON.stringify(data));
        observer.complete();
    });
}

function blobToText(blob: Blob): Observable<string> {
    return new Observable<string>(observer => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            try {
                blob.text().then((blobText: string) => {
                    observer.next(blobText);
                    observer.complete();
                }, err => observer.error(err));
            }
            catch { observer.error(); }
        }
    });
}